import {
  TrainingsCatalogPageDocument,
  TrainingsDataCollectionDocument,
  UpdateCatalogDocument,
  UpdateCatalogMutation,
  UpdateCatalogMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateCatalog = () => {
  const [updateCatalog, { loading }] = useMutation(UpdateCatalogDocument, {
    extractorFn: (data: UpdateCatalogMutation) =>
      data.trainingsMutations.bulkUpdateCatalogTrainingsTraining,
  })

  return {
    loading,
    updateCatalog(variables: UpdateCatalogMutationVariables) {
      return updateCatalog({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingsDataCollectionDocument, TrainingsCatalogPageDocument],
      })
    },
  }
}
